// extracted by mini-css-extract-plugin
export var text = "_4z-0";